import { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import category from "../../../src/assets/css/category.css";
import Swal from "sweetalert2"

const phoneNumber = "+800-123-4567 6587";
const initialAddress = "Beverley, New York 224 USA";

let socialList = [
    //{ iconName: 'fa-brands fa-instagram', siteLink: '#', color: '#f834f1ff' },
   // { iconName: 'fa-brands fa-facebook', siteLink: '#', color: '#1DA1F2' },
    { iconName: 'fa-brands fa-youtube', siteLink: 'https://youtu.be/x5YOxuTsuw4?si=LVzlrX2ys4-qlTDb', color: '#fd0a0aff' }
];

const HeaderWhite = () => {
    const [menuToggle, setMenuToggle] = useState(false);
    const [socialToggle, setSocialToggle] = useState(false);
    const [headerFixed, setHeaderFixed] = useState(false);
    const navigate = useNavigate();
    const [currentAddress, setCurrentAddress] = useState("");
    const [user, setUser] = useState(null);
    

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            setUser(null);
            return;
        }

        try {
            const decoded = jwtDecode(token);

            setUser({
                id: decoded.id,
                role: decoded.role,
                email: decoded.email
            });
        } catch (error) {
            console.log("Invalid token:", error);
            localStorage.removeItem("token");
            setUser(null);
        }
    }, []);

    const handleLogout = () => {
  localStorage.removeItem("token");
  setUser(null);
 
  Swal.fire({
    icon: "success",
    title: "Logged Out",
    text: "Redirecting to login...",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    width: 360,
    heightAuto: false,
    didClose: () => {
      navigate("/login");
    }
  });
};
 
 

    const chalkFont = {
        fontFamily: "'Freckle Face', cursive",
        fontSize: "20px",
        letterSpacing: "2px",
    };

    const homeColor = { color: "#d6cd20ff" };
    const singingColor = { color: "#FF6F61" };
    const danceColor = { color: "#F7E96E" };
    const paintingColor = { color: "#87CEEB" };
    const craftColor = { color: "#f73be7ff" };
    const morecolor = { color: "#f5800bff" };

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(async (pos) => {
            const lat = pos.coords.latitude;
            const lon = pos.coords.longitude;

            try {
                const res = await fetch(
                    `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`
                );
                const data = await res.json();

                const area = data.locality || data.localityInfo?.administrative?.[2]?.name;
                const city = data.city;
                const state = data.principalSubdivision;
                const country = data.countryName;

                setCurrentAddress(`${area}, ${city}, ${state}, ${country}`);
            } catch (error) {
                console.error("Location error:", error);
                setCurrentAddress("Unable to detect location");
            }
        },
            () => {
                setCurrentAddress("Hyderabad");
            });
    }, []);

    const mobileIconStyle = {
        color: '#fef9fbff',
        fontSize: '24px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: '0 8px',
    };

    const mobileIconContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        height: '100%',
    };

    return (

        
         <>
        <style>{`
            .kks-logo{
                width:204px;
                height:50px;
 
            }
            @media (max-width:765px){
            .kks-logo{
            width:204px;}}`}
        </style>
        <header className={`header-section ${headerFixed ? "header-fixed fadeInUp" : ""}`}>
            {/* Header Top */}
{/* Header Top */}
<div className="header-top" style={{ display: 'block' }}>
    <div className="container">
        <div className="header-top-area d-flex justify-content-between align-items-center">
            <ul className="lab-ul left d-flex" style={{ color: "white", margin: 0, padding: 0 }}>
                <li>
                    <i className="icofont-location-pin"></i> {currentAddress}
                </li>
            </ul>

            {/* Change: Added 'd-none d-lg-flex' to hide on mobile/tablet and show on desktop 
            <ul className="lab-ul social-icons d-none d-lg-flex align-items-center" style={{ margin: 0, padding: 0, gap: "10px" }}>
                <li><p style={{ color: "orange", margin: 0 }}>Find us on :</p></li>
                {socialList.map((val, i) => (
                    <li key={i}>
                          <a
    href={val.siteLink}
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: val.color }}
  >
    <i className={val.iconName}></i>
  </a>
                    </li>
                ))}
            </ul>*/}
        </div>
    </div>
</div>

            {/* Header Bottom */}
            <div className="header-bottom">
                <div className="container">
                    <div className="header-wrapper d-flex justify-content-between align-items-center">

                     <div className="logO "width="204px">
  <Link to="/">
    <img
      src="/assets/images/logo/NewLogo.png"
      alt="logo"
       className="kks-logo"
    />
  </Link>
</div>


                        {/* Menu Area */}
                        <div className="menu-area" style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                            <div className="menu" style={{ width: '100%', display: 'flex', justifyContent: 'right' }}>
                                <ul
                                    className={`lab-ul custom-hide-mobile ${menuToggle ? "active" : ""}`}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "7px",
                                    }}
                                >
                                    <li><NavLink to="/" style={{ ...chalkFont, ...homeColor }}>Home</NavLink></li>
                                    <li><NavLink to="/tutors/Music" style={{ ...chalkFont, ...singingColor }}>Music</NavLink></li>
                                    <li><NavLink to="/tutors/Dance" style={{ ...chalkFont, ...danceColor }}>Dance</NavLink></li>
                                    <li><NavLink end to="/tutors/Painting%20and%20Drawing" style={{ ...chalkFont, ...paintingColor }}>Painting & Drawing</NavLink></li>
                                    <li><NavLink to="/tutors/Crafts" style={{ ...chalkFont, ...craftColor }}>Crafts</NavLink></li>
                                    <li><NavLink to="/morearts" style={{ ...chalkFont, ...morecolor }}>More</NavLink></li>

                                    {user?.role === "student" && (
                                        <li><NavLink to="/student-profile" style={{ ...chalkFont, color: "orange" }}>My Profile</NavLink></li>
                                    )}
                                    {user?.role === "tutor" && (
                                        <li><NavLink to="/tutor-profile" style={{ ...chalkFont, color: "orange" }}>My Profile</NavLink></li>
                                    )}

                                    {/* Desktop Login Button */}
                                    <li className="custom-hide-mobile">
                                        {!user ? (
                                            <Link to="/login" style={{ backgroundColor: '#f0e8e6ff', border: 'none', borderRadius: '10px', fontWeight: 'bold', padding: '5px 15px', textDecoration: 'none', color: 'black' }}><span>Login</span></Link>
                                        ) : (
                                            <button onClick={handleLogout} style={{ backgroundColor: '#fc0909ff', border: 'none', borderRadius: '10px', fontWeight: 'bold', padding: '5px 15px', textDecoration: 'none', color: 'white' }}>
                                                <span>Logout</span>
                                            </button>
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Consolidated Mobile Icons */}
                        <div className="header-icon-links custom-hide-desktop custom-show-mobile-flex" style={mobileIconContainerStyle}>

                          
                          <div 
  
    onClick={() => setMenuToggle(!menuToggle)}
    style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '25px',
        height: '18px',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    }}
>
    <span style={{
        display: 'block',
        height: '2px',
        width: '100%',
         backgroundColor: '#e38912ff',
        transition: '0.3s',
        transform: menuToggle ? 'translateY(8px) rotate(45deg)' : 'none'
    }}></span>
    <span style={{
        display: 'block',
        height: '2px',
        width: '100%',
          backgroundColor: '#e38912ff',
        transition: '0.3s',
        opacity: menuToggle ? 0 : 1
    }}></span>
    <span style={{
        display: 'block',
        height: '2px',
        width: '100%',
        backgroundColor: '#e38912ff',
        transition: '0.3s',
        transform: menuToggle ? 'translateY(-8px) rotate(-45deg)' : 'none'
    }}></span>
</div>

                            <div>
                                {!user ? (
                                    <Link to="/login" style={{ backgroundColor: '#f0e8e6ff', border: 'none', borderRadius: '15px', fontWeight: 'bold', padding: '5px 15px', textDecoration: 'none', color: 'black' }}>
                                        <span>LOGIN</span>
                                    </Link>
                                ) : (
                                    <a onClick={handleLogout} className="logout-icon-link" style={{ ...mobileIconStyle, color: '#FF0000', borderRadius: '15px' }}>
                                      <i className="fa-solid fa-power-off"></i>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        </>
    );
};

export default HeaderWhite;